export default __webpack_public_path__ + "static/media/ROTAR_DISPOSITIVO.4bc8fa45.svg";